import { Contract } from '@/types/Facility';
import { InfraService } from '@/types/InfraService';
import { Property } from '@/types/State';
import type { UtilityMeteringPointResponse as MeteringPoint } from 'bff-api/mitt-malarenergi/v2';
import { find, get } from 'lodash';

export const allowedFuseSizes = [
  'lgh',
  '16a',
  '20a',
  '25a',
  '35a',
  '50a',
  '63a',
];
export const productNumbersWithTariff = ['el säkr', 'el säk eff', 'nät säkeff'];
export const lspProductNumbersWithTariff = ['lsp1', 'lsp2', 'lsp'];

export const getMeteringPointByUtilityTypeId = (
  meteringPoints: MeteringPoint[] | undefined,
  utilityId: number,
) =>
  find(
    meteringPoints,
    (meteringPoint) => meteringPoint.utilityType?.id === utilityId,
  );

export const getMeteringPointByMeteringPointId = (
  facilities: Property[] | undefined,
  meteringPointId: string | undefined,
) => {
  let newMeteringPoint: MeteringPoint | undefined;
  let foundMeteringPoint = false;

  facilities?.forEach((currentFacility) => {
    if (foundMeteringPoint) {
      return;
    }

    currentFacility?.meteringPoints?.forEach((meteringPoint) => {
      if (
        meteringPoint?.meteringPointId === meteringPointId &&
        meteringPoint?.meterNumber !== ''
      ) {
        newMeteringPoint = meteringPoint;
        foundMeteringPoint = true;
      } else if (
        meteringPoint.meteringPointId === meteringPointId &&
        newMeteringPoint === undefined
      ) {
        newMeteringPoint = meteringPoint;
      }
      if (foundMeteringPoint) {
        return;
      }
    });
  });

  return newMeteringPoint;
};

export const getMeteringPointContractsByMeteringPointId = (
  facilities: Property[] | undefined,
  meteringPointId: string | undefined,
) => {
  const meteringPointContracts: Contract[] = [];

  facilities?.forEach((currentFacility) => {
    currentFacility?.contracts?.forEach((contract) => {
      if (contract?.referenceId === meteringPointId) {
        meteringPointContracts?.push(contract);
      }
    });
  });

  return meteringPointContracts;
};

export const getInfraServiceFromFacility = (
  facility: Property | null,
  infraServiceName: InfraService['name'],
) =>
  find(
    facility?.infraServices,
    (infraService) => infraService?.name === infraServiceName,
  );

export const getFacilityKeyFromMeteringPointId = (
  facilities: Property[] | undefined | null,
  meteringPointId: string | undefined,
) =>
  facilities?.find((facility) =>
    facility?.meteringPoints?.some(
      (meteringPoint) => meteringPoint.meteringPointId === meteringPointId,
    ),
  )?.facilityKey;

export const isReadingTypeManual = (infraService: InfraService | undefined) =>
  infraService?.readingType?.name === 'MANUAL';

export const propertyHasFjvServiceAgreement = (property: Property | null) =>
  property?.services
    ? !!find(
        property.services,
        (service) => get(service, 'utilityType.id') === 7,
      )
    : false;

export const isPropertyAllFacilities = (property: Property | null) =>
  property?.groupId === '00000000-0000-0000-0000-000000000000';
